import axios from '../api'
import {
  GetTurnstileToken,
  TURNSTILE_FIELD,
  takeChallengeToken,
} from '../turnstile/challenge'

export { ChallengeFailedError, TURNSTILE_FIELD } from '../turnstile/challenge'

interface LoginRequest {
  username: string
  password: string
  getToken: GetTurnstileToken
}

export const login = async ({ username, password, getToken }: LoginRequest) => {
  const token = await takeChallengeToken(getToken)

  return axios.post('/login/', {
    username,
    password,
    ...(token ? { [TURNSTILE_FIELD]: token } : {}),
  })
}
